function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
import React from 'react';
import { MasterCardIcon, VisaIcon, AmericanExpressIcon, DinersClubIcon, MagnaIcon, RedcompraIcon, CardIcon } from '../../@theme/assets/svg/icons';
import { ChipCard, CreditInfoContainer, IconContainer, PortalContainer } from './styles/PortalCardCompressedStyled';
import { colors } from '../../@theme/colors';
var kindOfCard = {
  debit: {
    name: 'DÉBITO',
    color: colors.NotificacionesVerde
  },
  credit: {
    name: 'CRÉDITO',
    color: colors.NotificacionesAmarilloHover
  },
  prepaid: {
    name: 'PREPAGO',
    color: colors.NotificacionesAzul
  },
  "default": undefined
};
var brands = {
  visa: React.createElement(VisaIcon, null),
  mastercard: React.createElement(MasterCardIcon, null),
  americanexpress: React.createElement(AmericanExpressIcon, null),
  magna: React.createElement(MagnaIcon, null),
  diners: React.createElement(DinersClubIcon, null),
  prepago: React.createElement(RedcompraIcon, null),
  redcompra: React.createElement(RedcompraIcon, null),
  "default": React.createElement(CardIcon, null)
};
var PortalCardCompressed = function PortalCardCompressed(_ref) {
  var cardId = _ref.cardId,
    variant = _ref.variant,
    cardNumbers = _ref.cardNumbers,
    status = _ref.status,
    brand = _ref.brand,
    onClick = _ref.onClick;
  var kind = kindOfCard[variant];
  var creditNumbersMap = [].concat(_toConsumableArray(Array(3).fill('••••')), [cardNumbers]);
  var handleClick = function handleClick() {
    onClick && onClick(cardId);
  };
  return React.createElement(PortalContainer, {
    key: cardId,
    status: status,
    onClick: handleClick
  }, React.createElement(IconContainer, null, brands[brand], kind && React.createElement(ChipCard, {
    status: status,
    variant: kind.color
  }, kind.name)), React.createElement(CreditInfoContainer, null, creditNumbersMap.map(function (creditNumber, index) {
    return React.createElement("span", {
      key: creditNumber + index.toString()
    }, creditNumber);
  })));
};
export default PortalCardCompressed;